import React, { Component } from 'react';
import '../styles/Header.css';

class Header extends Component {
  render() {
    return (
      <header className="header">
        <h1>React CV Generator</h1>
      </header>
    );
  }
}

export default Header;
